import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../modules/auth'
import {shouldDisplayFonctionnalite} from '../../../../components/helpers'
import {ModeleSavDossierListe} from '../../../../components/sav/Models'
import {getSavDossiers} from '../../../../components/sav/requests'
import {formatSavDate, urlSavDossier} from '../../../../components/sav/libelles'
import SavStatutBadge from './SavStatutBadge'

type Props = {
  clientId?: number | string
  clientDemandeId?: number | string
}

// Carte SAV en lecture seule, pour la fiche demande et la fiche client
const SavCarteDossiers = ({clientId, clientDemandeId}: Props) => {
  const {currentUser} = useAuth()
  const [dossiers, setDossiers] = useState<Array<ModeleSavDossierListe> | null>(null)
  const autorise = shouldDisplayFonctionnalite(currentUser, 'SAV_CONSULTER')

  useEffect(() => {
    if (!autorise || (!clientId && !clientDemandeId)) return
    getSavDossiers(clientDemandeId ? {clientDemande: clientDemandeId} : {client: clientId})
      .then((r) => setDossiers(r.data))
      .catch(() => setDossiers([]))
  }, [autorise, clientId, clientDemandeId])

  if (!autorise || !dossiers?.length) return null

  return (
    <div className='card mb-5'>
      <div className='card-header min-h-50px'>
        <h3 className='card-title fs-5'>
          <i className='bi bi-arrow-repeat me-2'></i>SAV ({dossiers.length})
        </h3>
      </div>
      <div className='card-body py-3'>
        {dossiers.map((d) => (
          <div
            key={d.id}
            className='d-flex flex-wrap align-items-center gap-3 py-2 border-bottom border-gray-200'
          >
            <Link to={urlSavDossier(d)} className='fw-bolder text-gray-900 text-hover-success'>
              {d.numero}
            </Link>
            <SavStatutBadge code={d.statut.code} />
            <span className='text-muted'>{formatSavDate(d.dateCreation)}</span>
            <span>{d.lignes.map((l) => l.libellePiece).join(', ')}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SavCarteDossiers
